<template>
    <div id="show-root">
        <router-view></router-view>
        <footer-nav v-if="!HIDDEN_DETAILS"></footer-nav>
        <globalLimitTimeg v-if="COUPONDIALOGDATA && !isglobalLimitTimeg" ></globalLimitTimeg>
        <!-- 优惠活动logo -->
        <couponLogo
            :inDetailGo="true"
            :showProps="_setshowProps"
        ></couponLogo>
    </div>
</template>

<script>
    import footerNav from '../../components/show/footerNav'
    import globalLoading from '../../components/common/globalLoading.vue'
    import globalLimitTimeg from '@/components/show/globalLimitTimeg.vue'
    import couponLogo from "@/components/show/couponLogo.vue"
    import APIS from '@/apis';
    import {
        mapMutations,
        mapState,
        mapActions,
        mapGetters
    } from 'vuex';
    export default {
        name: 'app',
        components: {
            footerNav,
            globalLoading,
            globalLimitTimeg,
            couponLogo
        },
        data() {
            return {
              showTis: false,
            };
        },
        computed:{
            ...mapGetters(['COUPONDIALOGDATA']),
            // 使用内部弹窗组件，需要关闭回调
            isglobalLimitTimeg() {
                return this.$route.path == '/vip4Detail'
            }
        },
        mounted () {
            // console.log(this.$route)
            if (this.platform.isCeShiApp) {
                // 是口袋心理的话重定向到测评M站
                location.replace(`${location.origin}/cp-m/index.html?channelId=324#/manage?channelId=324`);
            }
            if (this.platform.isWechat && [513, 514, 501].includes(this.channelId)) {
                // 测评微站重定向渠道
                location.href = `${location.origin}${location.pathname}?channelId=1037#${this.$route.path}`;
            }
        },
        methods:{
            _detailGo(){
            }
        }
    }

</script>

<style lang="scss">
    @import '../../scss/function';
</style>



// WEBPACK FOOTER //
// src/pages/show/index.vue